import { CEProjectBase } from './ce-project-base'


export class CEProject extends CEProjectBase {

}